import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UpcomingGamesHeader } from "./UpcomingGamesHeader";
import { AddGameForm } from "./AddGameForm";
import { GamesTable } from "./GamesTable";
import { fetchGames, createGame, deleteGame, updateGameStatus } from "../../../features/game/gameSlice";

export const UpcomingGamesPage = () => {
  const dispatch = useDispatch();
  const { games, pagination, loading, error, createLoading, deleteLoading, statusUpdateLoading } = useSelector((state) => state.game);
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    dispatch(fetchGames({ page: 1, limit: 50 }));
  }, [dispatch]);

  const handleAddGame = async (gameData) => {
    try {
      await dispatch(createGame(gameData)).unwrap();
    } catch (err) {
      console.error('Failed to create game:', err);
    }
  };

  const handleDeleteGame = async (gameId) => {
    if (window.confirm('Are you sure you want to delete this game?')) {
      try {
        await dispatch(deleteGame(gameId)).unwrap();
      } catch (err) {
        console.error('Failed to delete game:', err);
      }
    }
  };

  const handleStatusChange = async (gameId, newStatus) => {
    try {
      await dispatch(updateGameStatus({ id: gameId, status: newStatus })).unwrap();
    } catch (err) {
      console.error('Failed to update game status:', err);
    }
  };

  // Filter games based on status
  const filteredGames = statusFilter === "all"
    ? games
    : games.filter(game => game.status === statusFilter);

  return (
    <div className="rounded-3xl bg-jp-card border border-jp-line shadow-sm p-6 space-y-5">
      {error && (
        <div className="p-3 bg-red-900/20 border border-red-500 rounded-lg">
          <p className="text-red-600 dark:text-red-400 text-sm">{error}</p>
        </div>
      )}

      <UpcomingGamesHeader
        status={statusFilter}
        onStatusChange={setStatusFilter}
      />
      <AddGameForm
        onAddGame={handleAddGame}
        loading={createLoading}
      />
      <GamesTable
        games={filteredGames}
        loading={loading}
        onDelete={handleDeleteGame}
        onStatusChange={handleStatusChange}
        deleteLoading={deleteLoading}
        statusUpdateLoading={statusUpdateLoading}
      />
    </div>
  );
};
